import React, { Component } from "react";
import cx from "classnames";
import scrollToComponent from "react-scroll-to-component";

import env from "../../../utils/env";

import Button, {
  buttonTypes,
  actionTypes
} from "@bit/fabfitfun.shared.global.button";

// Move into Bit
import ProductContainer from "../SharedComponents/ProductContainer/ProductContainer";
import PageNav from "../SharedComponents/PageNav/PageNav";

import { campaignState } from "../../../utils/campaignState";
import analytics, { events } from "../../../utils/analytics";
import { assignedStates } from "../../../utils/boxStates";

import BoxImage from "./box.png";

import "./ExplorePanel.css";

class ExplorePanel extends Component {
  state = {
    boxRevealed: false,
    currentPage: 1,
    pageLength: 5
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.sysdata.boxData &&
      prevProps.sysdata.boxData.curreentBox &&
      prevProps.sysdata.boxData.currentBox.boxRevealed !==
        this.props.sysdata.boxData.currentBox.boxRevealed
    ) {
      this.setState({
        boxRevealed: this.props.sysdata.boxData.currentBox.boxRevealed
      });
    }
  }

  getTotalValue = boxData => {
    let items = [];
    let total = 0;

    if (!boxData || !boxData.boxItems) {
      return total;
    }

    items = boxData.boxItems.concat(boxData.boxAdditionalChoices);

    items.forEach(item => {
      if (item && item.retailPrice) {
        total += item.retailPrice * (item.quantity || 1);
      }
    });
    return total;
  };

  getOpenStatus = boxData => {
    if (boxData && boxData.season) {
      const now = Date.now();
      if (now < new Date(boxData.season.addOnsEndDate)) {
        return campaignState.OPEN;
      }
    }
    return campaignState.CLOSED;
  };

  getItems = boxData => {
    let items = [];
    if (!boxData) {
      return items;
    }

    if (boxData.boxAdditionalChoices) {
      items = items.concat(boxData.boxAdditionalChoices);
    }
    if (boxData.currentBox && boxData.currentBox.boxRevealed) {
      items = items.concat(boxData.boxItems);
    }

    return items;
  };

  getPageItems = boxData => {
    const items = this.getItems(boxData);
    const { currentPage, pageLength } = this.state;

    if (!items || !items.length) {
      return [];
    }

    const start = (currentPage - 1) * pageLength;
    const end = start + pageLength;

    return items.slice(start, end);
  };

  reveal = shipstationId =>
    this.props.sysdata
      .saveRevealState(shipstationId, true)
      .then(this.props.sysdata.revealCallback);

  render() {
    const { sysdata = {} } = this.props;
    const { pageLength } = this.state;
    const { boxData = {}, isMobile, isSharedBox } = sysdata;
    const { currentBox } = boxData;
    const status = this.getOpenStatus(boxData);
    const totalValue = this.getTotalValue(boxData);
    const items = this.getItems(boxData);
    const pageItems = this.getPageItems(boxData);
    const boxRevealed = currentBox && currentBox.boxRevealed;
    const currentBoxName = currentBox ? currentBox.name : "";
    const shipstationId = currentBox ? currentBox.shipstationId : 0;

    const statusContainerStyle = cx({
      "d-flex": isMobile,
      "flex-jsa": isMobile
    });

    const totalValueStyle = cx({
      "mar-h-4": true,
      "c-black-60": true,
      "ff-ns": true,
      "d-flex": true,
      "flex-aic": true
    });

    const titleStyle = cx({
      "mar-0": true,
      "ta-center": isMobile,
      "ff-pds": true,
      "fs-36": true,
      "fw-normal": true,
      "add-ons-view-title": true
    });

    const containerStyle = cx({
      "d-flex": true,
      "flex-jsb": true,
      "flex-fdc": isMobile,
      "flex-aic": isMobile
    });

    const productGridWrapperStyle = cx({
      "w-60": !isMobile && !boxRevealed
    });

    return (
      <div className="explore-panel">
        <div className="mar-h-16">
          <h1
            ref={section => {
              this.Header = section;
            }}
            className={titleStyle}
          >
            Explore your {currentBoxName}
          </h1>
          {boxRevealed && (
            <div className={statusContainerStyle}>
              <div className={totalValueStyle}>
                Total Value: {`$${totalValue.toFixed(2)}`}
              </div>
            </div>
          )}
        </div>

        {/* User has items */}
        {/* {!!items.length && ( */}
        <div className={containerStyle}>
          {isMobile && items.length > pageLength && (
            <PageNav
              maxPageCount={4}
              currentPage={this.state.currentPage}
              totalPages={Math.ceil(items.length / pageLength)}
              onChange={pg => {
                this.setState({ currentPage: pg });
                scrollToComponent(this.Header, {
                  offset: 0,
                  align: "top",
                  duration: 500
                });
              }}
            />
          )}
          {!!items.length && (
            <div className={productGridWrapperStyle}>
              <ProductContainer
                products={isMobile ? pageItems : items}
                exploreDisplay={true}
                open={status === campaignState.OPEN}
                viewAll={true}
                isMobile={isMobile}
                hasBeenAssigned={assignedStates.includes(boxData.currentBox.boxStatus)}
                isSharedBox={isSharedBox}
              />
            </div>
          )}
          {!boxRevealed && (
            <div className="w-100 summary-details">
              {!isMobile && (
                <div className="ta-center">
                  <img
                    className="reveal-box-image"
                    alt="Reveal your box!"
                    src={`${env.cfURL}/static/media/box.3a32c684.png`}
                  />
                </div>
              )}

              {!isMobile && (
                <div className="lh-lg ta-center ff-ns fs-18 fw-bold">
                  Ready to Look Inside Your {currentBoxName} Box?
                </div>
              )}
              <Button
                type={buttonTypes.PRIMARY.value}
                action={actionTypes.CALL_TO_ACTION.value}
                label="Reveal All"
                style={{ width: "100%", margin: "12px 0 0" }}
                onClick={() => {
                  this.setState({ boxRevealed: true });
                  analytics.track(events.CLICKED_ELEMENT, {
                    element_name: "Reveal Now",
                    option_title: `Explore your ${currentBoxName} Box`
                  });
                  this.reveal(shipstationId);
                }}
              />
            </div>
          )}
        </div>

        <br />
        {isMobile && items.length > pageLength && (
          <PageNav
            maxPageCount={4}
            currentPage={this.state.currentPage}
            totalPages={Math.ceil(items.length / pageLength)}
            onChange={pg => {
              this.setState({ currentPage: pg });
              scrollToComponent(this.Header, {
                offset: 0,
                align: "top",
                duration: 500
              });
            }}
          />
        )}

        <div className="hor-rule" />
      </div>
    );
  }
}

export default ExplorePanel;

ExplorePanel.defaultProps = {
  boxData: {
    currentBox: {}
  }
};



// WEBPACK FOOTER //
// ./src/Components/Panels/ExplorePanel/ExplorePanel.js